import { schema } from "normalizr";

const offers = new schema.Entity("offers");
export const offersList = new schema.Array(offers);

export const openBuy = new schema.Entity("openBuy");
